export function hasJsonWebTokenFormat(maybe_jwt: string) {
  return (
    typeof maybe_jwt === "string" &&
    maybe_jwt.match(/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/) !== null
  );
}
